module.exports = __webpack_public_path__ + "static/media/stop-start.4fd5427e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/stop-start.svg
// module id = 861
// module chunks = 0